module.exports = __webpack_public_path__ + "img/oelsnitz-media.cc1f63ac.png";